export default __webpack_public_path__ + "static/media/NPR_Index_diagram.d522a731.png";